<template>
  <div class="signatureBox">
    <div ref="canvasHW" class="canvasBox">
      <div class="signature-btn">
        <van-button
          size="small"
          class="btn"
          type="info"
          @click.native.prevent="handleGoBack()"
        >
          返回
        </van-button>
        <van-button
          size="small"
          class="btn"
          type="info"
          @click.native.prevent="handleOverwrite()"
        >
          重签
        </van-button>
        <van-button
          size="small"
          class="btn"
          type="info"
          @click.native.prevent="handleSubmit()"
        >
          提交
        </van-button>
      </div>
      <div class="canvas">
        <canvas
          ref="canvasF"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
        ></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import { postSignContract } from "@/api/app/roster";
export default {
  data() {
    return {
      // img: "",
      points: [],
      canvasTxt: null,
      stage_info: [],
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      isDown: false,
      strokeStyle: "#000",
      lineWidth: 2,
    };
  },
  mounted() {
    this.$store.dispatch("submitToken");
    this.initCanvas();
    // 监听resize方法
    window.addEventListener("resize", this.renderResize, false);
    this.$notify({ type: "warning", message: "请在微信设置的通用内开启横屏模式！" });

    // window.addEventListener("resize", this.resize());
  },

  beforeDestroy() {
    // 移除监听
    window.removeEventListener("resize", this.renderResize, false);
  },
  methods: {
    initCanvas() {
      let canvas = this.$refs.canvasF;
      // let angle = (0 * Math.PI) / 180;
      // 获取画布的高度
      canvas.height = this.$refs.canvasHW.offsetHeight + 250;
      // 获取画布的宽度
      canvas.width = this.$refs.canvasHW.offsetWidth + 50;
      this.canvasTxt = canvas.getContext("2d");
      this.stage_info = canvas.getBoundingClientRect();
    },
    // 移动设备事件
    touchStart(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stage_info.left,
          y: ev.targetTouches[0].clientY - this.stage_info.top,
        };
        this.startX = obj.x;
        this.startY = obj.y;
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.points.push(obj);
      }
    },
    touchMove(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stage_info.left,
          y: ev.targetTouches[0].clientY - this.stage_info.top,
        };
        this.moveY = obj.y;
        this.moveX = obj.x;
        // 设置线条颜色
        this.canvasTxt.strokeStyle = this.strokeStyle;
        // 设置线条宽度
        this.canvasTxt.lineWidth = this.lineWidth;
        // 绘制开始路径
        this.canvasTxt.beginPath();
        // 定义线条开始坐标
        this.canvasTxt.moveTo(this.startX, this.startY);
        // 定义线条结束坐标
        this.canvasTxt.lineTo(obj.x, obj.y);
        // 绘制线条
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.startY = obj.y;
        this.startX = obj.x;
        this.points.push(obj);
      }
    },
    // 移动设备事件
    touchEnd(ev) {
      ev = ev || event;
      ev.preventDefault();
      if (ev.touches.length == 1) {
        let obj = {
          x: ev.targetTouches[0].clientX - this.stage_info.left,
          y: ev.targetTouches[0].clientY - this.stage_info.top,
        };
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.points.push(obj);
        this.points.push({ x: -1, y: -1 });
      }
    },
    // 返回
    handleGoBack() {
      this.handleOverwrite();
      this.$emit("back");
      this.$router.push({ path: "/recruit" });
    },
    // 重写
    handleOverwrite() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height);
      this.points = [];
    },
    // 提交
    handleSubmit() {
      let form = this.$store.state.app.content;
      if (this.points.length < 50) {
        return;
      }
      this.$emit("content", this.$refs.canvasF.toDataURL());
      form.signUrl = this.$refs.canvasF.toDataURL().substring(22);
      postSignContract(form)
        .then((res) => {
          if (res.code == 200) {
            this.$notify({ type: "success", message: "签订成功！" });
            this.$router.push({ path: "/recruit" });
          }
        })
        .catch((error) => {
          this.$store.dispatch("submitToken");
        });
      // this.$router.back();
    },
    renderResize() {
      // 判断横竖屏
      location.reload();
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (width > height) {
        document.documentElement.webkitRequestFullScreen();
        this.initCanvas();
        this.$notify({ type: "success", message: "横屏模式开启成功！" });
      }
    },

    // // 横屏
    // resize() {
    //   let width = window.innerWidth,
    //     height = window.innerHeight,
    //     $wrapper = document.getElementById("app"),
    //     style = "";
    //   if (width >= height) {
    //     // 横屏
    //     style += "width:" + width + "px;"; // 注意旋转后的宽高切换
    //     style += "height:" + height + "px;";
    //     style += "-webkit-transform: rotate(0); transform: rotate(0);";
    //     style += "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //     style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //   } else {
    //     // 竖屏
    //     style += "width:" + height + "px;";
    //     style += "height:" + width + "px;";
    //     style += "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
    //     // 注意旋转中点的处理
    //     style += "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //     style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //   }
    //   $wrapper.style.cssText = style;

    //   // if (window.orientation == 180 || window.orientation == 0) {
    //   //   alert("竖屏状态！");
    //   // }
    //   // if (window.orientation == 90 || window.orientation == -90) {
    //   //   let newX, newY;
    //   //   this.$canvas.on("mousedown touchstart", (event) => {
    //   //     if (event.type.indexOf("touch") !== -1) {
    //   //       newX = event.touches[0].clientY - canvas.offsetTop;
    //   //       //伪横屏的情况下， canvas上下是全部撑满的  canvas.offsetTop = 0； newX =  oldY
    //   //       newY = canvas.width + 40 - event.touches[0].clientX;
    //   //     } else {
    //   //       newX = event.clientY - this.canvas.offsetTop;

    //   //       newY = this.canvas.width + 40 - event.clientX;
    //   //     }
    //   //   });
    //   // }
    // },
  },
};
</script>
<style lang="less" scoped>
.signatureBox {
  min-height: 100vh;
  // margin-top: 60px;
  background-color: #f0f0f0;
}
.signature-btn {
  top: 10px;
  padding: 10px 10px 0 0;
  position: absolute;
  right: 0;
  text-align: right;
}
// .canvas{

//   position: relative;
// }
.btn {
  margin-left: 5px;
}
/deep/ .avue-sign__canvas {
  width: 100%;
  height: 250px;
}
.result {
  display: flex;
  margin-top: 10px;
  span {
    align-self: start;
    margin-left: 5px;
  }
}
</style>
